export const calendarTypes = {
    provider: "Provider",
    clinic: "Clinic",
    equipment: "Equipment",
}